export default "__VITE_ASSET__Bcit9blT__"